<form *ngIf="reportForm" [formGroup]="reportForm">
  <div class="row row d-flex justify-content-center my-3">
    <div class="col-12">
      <div class="form-group">
        <label>คำอธิบายรายงานแบบทดสอบ</label>
        <textarea formControlName="TEMPLATE_DES" class="form-control" rows="3" maxlength="1500"></textarea>
        <p class="text-right">{{ reportForm.value.TEMPLATE_DES.length | number }}/1,500</p>
      </div>
    </div>

    <h3 class="text-center my-4">ลักษณะทางจิตวิทยา</h3>
    <div class="col-12">
      <div *ngFor="let r of reportForm.get('PSY_BLOCKS')['controls']; let i = index" formArrayName="PSY_BLOCKS">
        <div [formGroupName]="i" class="box mt-4">
          <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removePsyBlocks(i)"
            [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          <div class="form-group row" style="margin-top: 60px;">
            <label class="col-sm-3 col-form-label">ลักษณะทางจิตวิทยา</label>
            <div class="col-sm-9">
              <input formControlName="PSY_NAME" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-3 col-form-label">สี</label>
            <div class="col-sm-9">
              <input formControlName="COLOR_CODE" type="color" class="form-control" style="width: 20%;">
              <small *ngIf="!r.value.COLOR_CODE" class="col-form-label" class="text-danger">
                ยังไม่ได้ใส่สี ✖
              </small>
              <small *ngIf="r.value.COLOR_CODE" class="col-form-label" class="text-success">
                ใส่สีเรียบร้อย ✔
              </small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
            <textarea formControlName="DETAIL_PSY" class="form-control" rows="3" maxlength="1500"></textarea>
            <p class="text-right">{{ reportForm.value.PSY_BLOCKS[i].DETAIL_PSY.length | number }}/1,500</p>
          </div>

          <div class="row justify-content-center">
            <lifedi-btn *ngIf="!r.value.CAL" lable="การคำนวณ" (click)="openCalculateModal(r, i, false)"
              customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn *ngIf="r.value.CAL" lable="แก้ไขการคำนวณ" (click)="openCalculateModal(r, i, true)"
              customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
            </lifedi-btn>
          </div>

          <div class="row justify-content-center">
            <small *ngIf="!r.value.CAL" class="col-form-label" class="text-danger">
              ยังไม่ได้ใส่วิธีการคำนวณ ✖
            </small>
            <small *ngIf="r.value.CAL" class="col-form-label" class="text-success">
              ใส่วิธีการคำนวณแล้ว ✔
            </small>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <lifedi-btn lable="เพิ่มลักษะทางจิตวิทยา" (click)="addGroup()"
          customStyle="background-color: #00AF80; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>


    <div class="col-12">
      <h3 class="text-center my-4">กลุ่ม</h3>
      <div *ngFor="let c of reportForm.get('CHART_DATA')['controls']; let i = index" formArrayName="CHART_DATA"
        class="chartBox mb-3">
        <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removeChartData(i)"
          [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
        <h3 class="text-center pt-3">Chart {{i+1}}</h3>
        <div [formGroupName]="i">
          <div class="subBox">
            <div formGroupName="X_VALUE" class="mt-3">
              <div class="row">
                <h3 class="col-12">ค่าบนแกน X</h3>
              </div>
              <div class="form-group row">
                <label class="col-3 col-form-label">ลักษณะทางจิตวิทยา</label>
                <div class="col-9">
                  <select class="custom-select" formControlName="PSY_BLOCKS_ID"
                    (change)="selectPsyBlocks(c, $event, 'X')">
                    <option hidden value="">เลือกลักษณะทางจิตวิทยา</option>
                    <option *ngFor="let b of reportForm.value.PSY_BLOCKS" [value]="b.PSY_BLOCKS_ID">
                      {{ b.PSY_NAME }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div formGroupName="Y_VALUE" class="mt-3">
              <div class="row">
                <h3 class="col-12">ค่าบนแกน Y</h3>
              </div>
              <div class="form-group row">
                <label class="col-3 col-form-label">ลักษณะทางจิตวิทยา</label>
                <div class="col-9">
                  <select class="custom-select" formControlName="PSY_BLOCKS_ID"
                    (change)="selectPsyBlocks(c, $event, 'Y')">
                    <option hidden value="">เลือกลักษณะทางจิตวิทยา</option>
                    <option *ngFor="let b of reportForm.value.PSY_BLOCKS" [value]="b.PSY_BLOCKS_ID">
                      {{ b.PSY_NAME }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- ซ้ายบน -->

          <div formGroupName="LEFTTOP_BOX" class="subBox mt-3 pt-3">
            <div class="row">
              <h3 class="col-12">
                กล่องซ้ายบน
                <img src="../../../../assets/topleft.png" alt="" width="23px" style="margin-bottom: 5px;">
              </h3>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">ชื่อประเภท</label>
              <div class="col-10">
                <input formControlName="TYPE_NAME" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีกล่อง</label>
              <div class="col-10">
                <input formControlName="COLOR_BOX" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.LEFTTOP_BOX.COLOR_BOX" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.LEFTTOP_BOX.COLOR_BOX" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีตัวหนังสือ</label>
              <div class="col-10">
                <input formControlName="COLOR_TEXT" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.LEFTTOP_BOX.COLOR_TEXT" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.LEFTTOP_BOX.COLOR_TEXT" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <p class="text-center"><b>กำหนดจุด</b></p>
            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_TOP" class="row">
                  <div class="col-12 mb-2">ซ้ายบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_TOP" class="row">
                  <div class="col-12 mb-2">ขวาบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_BOT" class="row">
                  <div class="col-12 mb-2">ซ้ายล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_BOT" class="row">
                  <div class="col-12 mb-2">ขวาล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
              <textarea formControlName="DESCRIPTION" class="col-12 form-control" rows="3" maxlength="1500"></textarea>
              <span class="col-12 text-right">{{ c.value.LEFTTOP_BOX.DESCRIPTION.length | number }}/1,500</span>
            </div>
          </div>

          <!-- ขวาบน -->

          <div formGroupName="RIGHTTOP_BOX" class="subBox mt-3 pt-3">
            <div class="row">
              <h3 class="col-12">
                กล่องขวาบน
                <img src="../../../../assets/topright.png" alt="" width="23px" style="margin-bottom: 5px;">
              </h3>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">ชื่อประเภท</label>
              <div class="col-10">
                <input formControlName="TYPE_NAME" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีกล่อง</label>
              <div class="col-10">
                <input formControlName="COLOR_BOX" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.RIGHTTOP_BOX.COLOR_BOX" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.RIGHTTOP_BOX.COLOR_BOX" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีตัวหนังสือ</label>
              <div class="col-10">
                <input formControlName="COLOR_TEXT" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.RIGHTTOP_BOX.COLOR_TEXT" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.RIGHTTOP_BOX.COLOR_TEXT" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <p class="text-center"><b>กำหนดจุด</b></p>
            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_TOP" class="row">
                  <div class="col-12 mb-2">ซ้ายบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_TOP" class="row">
                  <div class="col-12 mb-2">ขวาบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_BOT" class="row">
                  <div class="col-12 mb-2">ซ้ายล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_BOT" class="row">
                  <div class="col-12 mb-2">ขวาล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
              <textarea formControlName="DESCRIPTION" class="col-12 form-control" rows="3" maxlength="1500"></textarea>
              <span class="col-12 text-right">{{ c.value.RIGHTTOP_BOX.DESCRIPTION.length | number }}/1,500</span>
            </div>
          </div>

          <!-- ซ้ายล่าง -->

          <div formGroupName="LEFTBT_BOX" class="subBox mt-3 pt-3">
            <div class="row">
              <h3 class="col-12">
                กล่องซ้ายล่าง
                <img src="../../../../assets/bottomleft.png" alt="" width="23px" style="margin-bottom: 5px;">
              </h3>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">ชื่อประเภท</label>
              <div class="col-10">
                <input formControlName="TYPE_NAME" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีกล่อง</label>
              <div class="col-10">
                <input formControlName="COLOR_BOX" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.LEFTBT_BOX.COLOR_BOX" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.LEFTBT_BOX.COLOR_BOX" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีตัวหนังสือ</label>
              <div class="col-10">
                <input formControlName="COLOR_TEXT" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.LEFTBT_BOX.COLOR_TEXT" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.LEFTBT_BOX.COLOR_TEXT" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <p class="text-center"><b>กำหนดจุด</b></p>
            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_TOP" class="row">
                  <div class="col-12 mb-2">ซ้ายบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_TOP" class="row">
                  <div class="col-12 mb-2">ขวาบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_BOT" class="row">
                  <div class="col-12 mb-2">ซ้ายล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_BOT" class="row">
                  <div class="col-12 mb-2">ขวาล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
              <textarea formControlName="DESCRIPTION" class="col-12 form-control" rows="3" maxlength="1500"></textarea>
              <span class="col-12 text-right">{{ c.value.LEFTBT_BOX.DESCRIPTION.length | number }}/1,500</span>
            </div>
          </div>

          <!-- ขวาล่าง -->

          <div formGroupName="RIGHTBT_BOX" class="subBox mt-3 pt-3">
            <div class="row">
              <h3 class="col-12">
                กล่องขวาล่าง
                <img src="../../../../assets/bottomright.png" alt="" width="23px" style="margin-bottom: 5px;">
              </h3>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">ชื่อประเภท</label>
              <div class="col-10">
                <input formControlName="TYPE_NAME" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีกล่อง</label>
              <div class="col-10">
                <input formControlName="COLOR_BOX" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.RIGHTBT_BOX.COLOR_BOX" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.RIGHTBT_BOX.COLOR_BOX" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">สีตัวหนังสือ</label>
              <div class="col-10">
                <input formControlName="COLOR_TEXT" type="color" class="form-control" style="width: 20%;">
                <small *ngIf="!c.value.RIGHTBT_BOX.COLOR_TEXT" class="col-form-label" class="text-danger">
                  ยังไม่ได้ใส่สี ✖
                </small>
                <small *ngIf="c.value.RIGHTBT_BOX.COLOR_TEXT" class="col-form-label" class="text-success">
                  ใส่สีเรียบร้อย ✔
                </small>
              </div>
            </div>
            <p class="text-center"><b>กำหนดจุด</b></p>
            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_TOP" class="row">
                  <div class="col-12 mb-2">ซ้ายบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_TOP" class="row">
                  <div class="col-12 mb-2">ขวาบน</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6">
                <div formGroupName="LEFT_BOT" class="row">
                  <div class="col-12 mb-2">ซ้ายล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
              <div class="col-6">
                <div formGroupName="RIGHT_BOT" class="row">
                  <div class="col-12 mb-2">ขวาล่าง</div>
                  <label class="col-1 col-form-label">X</label>
                  <div class="col-5"><input formControlName="X" class="form-control" type="number"></div>
                  <label class="col-1 col-form-label">Y</label>
                  <div class="col-5"><input formControlName="Y" class="form-control" type="number"></div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
              <textarea formControlName="DESCRIPTION" class="col-12 form-control" rows="3" maxlength="1500"></textarea>
              <span class="col-12 text-right">{{ c.value.RIGHTBT_BOX.DESCRIPTION.length | number }}/1,500</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-2 justify-content-center">
        <button mat-mini-fab class="img" (click)="addChart()"
          [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
        </button>
      </div>
    </div>
  </div>
</form>
